/** Path of a brand's page. Its own module: the hero and the marquee need nothing else from the selection code. */
export const brandHref = (brand) => `/brands/${brand.countrySlug}/${brand.slug}`;
